<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
  width:100%;
  min-width: 1440px;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #fff;
}
#app{
  width:100%;
  min-height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #e1e1e2;
}
body table{
  overflow: hidden!important;
}
body .el-table th.gutter{
    display: table-cell!important;
}
body .el-button--primary{
  background-color: #409EFF!important;
  border-color: #409EFF!important;
}
body .el-button--text, body .tabTit .item.active{
  color: #409EFF!important;
}
body .el-pagination.is-background .el-pager li:not(.disabled).active, body .tabTit .item.active span{
  background-color: #409EFF!important;
}
body .el-checkbox__input.is-checked+.el-checkbox__label, body .el-radio__input.is-checked+.el-radio__label{
  color: #409EFF!important;
}
body .el-checkbox__input.is-checked .el-checkbox__inner,body .el-checkbox__input.is-indeterminate .el-checkbox__inner,body .el-radio__input.is-checked .el-radio__inner {
  background-color: #409EFF!important;
  border-color: #409EFF!important;
}
body .el-button--primary.settingBtn{
  color: #409EFF;
  border-color: #409EFF!important;
  background-color: #D9ECFF!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue